<p-table
  #dt
  [resizableColumns]="true"
  [columns]="selectedColumns"
  [value]="data"
  [styleClass]="lang.isEnglish ? '' : 'rtl'"
  [rows]="tableCore.pageOptions.limit"
  [paginator]="false"
  [(selection)]="selectedData"
  [dataKey]="id"
  (onRowSelect)="onRowSelect($event)"
  (onRowUnselect)="onRowUnselect($event)"
  class="table table-hover table-style"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <!-- <th *ngIf="options.check" style="width: 3rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th> -->
      <th *ngFor="let col of columns" pResizableColumn [style.width]="col.width ? col.width : '250px'">
        {{ col.header | translate }}
      </th>

      <th *ngIf="actions" style="width: 250px">
        <div class="header-wrap d-flex justify-content-between align-items-center">
          <span class="title">{{ 'common.actions' | translate }}</span>
          <div dropdown container="body" placement="bottom right">
            <a
              href="javascript:"
              dropdownToggle
              aria-controls="table-actions"
              id="table-drop-action"
              style="padding: 0.5rem"
            >
              <i class="fas fa-ellipsis-v"></i>
            </a>
            <ul
              id="table-actions"
              *dropdownMenu
              class="dropdown-menu custome-dropdown"
              [ngClass]="lang.isEnglish() ? 'dropdown-menu-right' : ''"
              role="menu"
              aria-labelledby="table-drop-action"
            >
              <li role="menuitem" *ngIf="url && url.import"></li>

              <li role="menuitem" *ngIf="url && url.updateByFile"></li>

              <li role="menuitem" *ngIf="url && url.fill"></li>

              <li role="menuitem" *ngIf="url && url.export">
                <a (click)="export()" class="dropdown-item">
                  <i class="fas fa-file-alt" [ngClass]="lang.isEnglish() ? 'mr-2' : 'ml-2'"></i>
                  {{ 'common.export' | translate }}
                </a>
              </li>

              <li role="menuitem" *ngIf="clientSide">
                <a (click)="dt.exportCSV()" class="dropdown-item">
                  <i class="fas fa-file-alt" [ngClass]="lang.isEnglish() ? 'mr-2' : 'ml-2'"></i>
                  {{ 'common.export' | translate }}
                </a>
              </li>
              <li *ngIf="!options.globalSearch" role="menuitem">
                <a (click)="options.search = !options.search" class="dropdown-item">
                  <i class="fas fa-file-alt" [ngClass]="lang.isEnglish() ? 'mr-2' : 'ml-2'"></i>
                  {{ 'common.toggleSearch' | translate }}
                </a>
              </li>
              <li class="divider dropdown-divider"></li>
              <li role="menuitem">
                <a class="dropdown-item disabled text-muted">Column Filtered</a>
              </li>
              <li role="menuitem">
                <a *ngFor="let item of columnsI" class="dropdown-item">
                  <p-checkbox
                    name="columnsGroup"
                    [value]="item"
                    [label]="item.header | translate"
                    [inputId]="item.header"
                    [(ngModel)]="selectedColumns"
                    (onChange)="updateSelectedColumnsAPI()"
                  >
                  </p-checkbox>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </th>
    </tr>
    <!-- <tr *ngIf="!options.globalSearch && options.search">
      <th *ngIf="options.check"></th>
      <th *ngFor="let col of columns">
        <div class="text" *ngIf="!col.filterMode || col.filterMode === 'text'">
          <input
            pInputText
            *ngIf="!(col.field === 'action')"
            type="text"
            style="width: 100%; padding: 6px"
            (input)="
              clientSide
                ? dt.filter($event.target.value, col.field, col.filterMatchMode)
                : columnSearchHandle($event.target.value, col.field)
            "
          />
        </div>
      </th>
      <th *ngIf="actions"></th>
    </tr> -->
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <!-- <td *ngIf="options.check">
        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
      </td> -->
      <td
        *ngFor="let col of columns; let i = index"
        [title]="rowData[col.field + 'Message'] ? rowData[col.field + 'Message'] : rowData[col.field]"
        [class]="rowData[col.field + 'Message'] ? 'bg-danger text-white' : ''"
        class="ui-resizable-column"
        style="white-space: nowrap; height: 50px;"
      >
        <div *ngIf="!col.editable">
          <div *ngIf="col.customCell; else default">
            <div
              *ngIf="col.customCell === 'boolean' && rowData[col.field]"
              [class]="
                col.filterDropdown[0].cssClasses
                  ? col.filterDropdown[0].cssClasses
                  : 'rounded-pill bg-success text-white'
              "
              style="min-height: 30px; padding: 5px 10px 5px 20px"
            >
              {{ col.filterDropdown[0].label | translate }}
            </div>

            <div
              *ngIf="col.customCell === 'boolean' && !rowData[col.field]"
              style="min-height: 30px; padding: 5px 10px 5px 20px"
              [class]="
                col.filterDropdown[1].cssClasses
                  ? col.filterDropdown[1].cssClasses
                  : 'rounded-pill bg-danger text-white'
              "
            >
              {{ col.filterDropdown[1].label | translate }}
            </div>

            <div *ngIf="col.customCell === 'date'">
              {{ rowData[col.field] | date }}
            </div>

            <div *ngIf="col.customCell === 'currency'">
              {{ rowData[col.field] | currency }}
            </div>

            <div *ngIf="col.customCell === 'customStyle'">
              <div *ngFor="let item of col.filterDropdown">
                <div
                  *ngIf="item.value === rowData[col.field]"
                  [class]="item.cssClasses + ' rounded-pill'"
                  style="min-height: 30px; padding: 5px 10px 5px 20px"
                >
                  {{ item.label | translate }}
                </div>
              </div>
            </div>
          </div>

          <ng-template #default>
            {{ rowData[col.field] }}
          </ng-template>
        </div>

        <div *ngIf="col.editable">
          <div *ngIf="col.form.type === 'text'" class="form-text">
            <input pInputText type="text" style="width: 100%; padding: 6px" />
          </div>

          <div *ngIf="col.form.type === 'password'" class="form-text">
            <input pInputText type="password" style="width: 100%; padding: 6px" />
          </div>
        </div>
      </td>

      <td *ngIf="actions">
        <div class="actions-wrap d-flex">
          <div class="btn-group" dropdown container="body">
            <div
              *ngIf="options.details"
              class="btn-details"
              [ngClass]="{
                'mr-2': lang.isEnglish(),
                'ml-2': !lang.isEnglish()
              }"
            >
              <button type="button" class="btn btn-sm btn-outline-dark" (click)="goToDetailsPage(rowData[id])">
                <i class="fas fa-eye fa-fw"></i>
              </button>
            </div>
            <button
              id="button-container"
              dropdownToggle
              type="button"
              class="btn btn-sm btn-outline-dark dropdown-toggle"
              aria-controls="dropdown-container"
              *ngIf="actions.length"
            >
              <i class="fas fa-cog fa-fw"></i>
            </button>
            <ul
              id="dropdown-container"
              *dropdownMenu
              class="dropdown-menu"
              role="menu"
              aria-labelledby="button-container"
            >
              <li *ngFor="let action of actions" role="menuitem">
                <a
                  *ngIf="action.isEdit"
                  class="dropdown-item"
                  (click)="action.call ? action.call() : goToEditPage(rowData[id])"
                  style="cursor: pointer"
                >
                  <i [class]="action.icon || 'fas fa-edit'"></i>
                  {{ 'table.edit' | translate }}
                </a>

                <a
                  *ngIf="action.isDelete"
                  class="dropdown-item"
                  [ngClass]="{
                    'bg-danger text-light': rowData.isBlock
                  }"
                  (click)="action.call ? action.call() : delete(rowData[id])"
                  style="cursor: pointer"
                >
                  <i [class]="action.icon || 'far fa-trash-alt'"></i>
                  {{ 'table.delete' | translate }}
                </a>

                <a
                  *ngIf="action.isBlock"
                  class="dropdown-item"
                  [ngClass]="{
                    'bg-danger text-light': rowData.isBlock
                  }"
                  (click)="action.call ? action.call() : deleteSwal.fire()"
                  style="cursor: pointer"
                >
                  <i [class]="action.icon || 'far fa-trash-alt'"></i>
                  {{ rowData.isBlock ? ('table.unBlock' | translate) : ('table.block' | translate) }}
                </a>

                <a
                  *ngIf="!action.isDelete && !action.isBlock && !action.isDetails && !action.isEdit"
                  class="dropdown-item"
                  (click)="action.call(rowData)"
                  style="cursor: pointer"
                >
                  <i [class]="action.icon"></i>
                  {{ action.name | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<!-- <div class="footer d-flex justify-content-between">
  <div class="paginator">
    <p-paginator
      styleClass="table-paginator {{ lang.isEnglish() ? '' : 'rtl' }}"
      [rows]="tableCore.pageOptions.limit"
      (onPageChange)="setPage($event)"
      [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
      [totalRecords]="tableCore.pageOptions.count"
    ></p-paginator>
  </div>
  <div class="count">
    {{
      tableCore.pageOptions.offset * tableCore.pageOptions.limit + 1 <= tableCore.pageOptions.count
        ? tableCore.pageOptions.offset * tableCore.pageOptions.limit + 1
        : tableCore.pageOptions.count != -1
        ? tableCore.pageOptions.count
        : columnsI.length
    }}
    -
    {{
      tableCore.pageOptions.offset * tableCore.pageOptions.limit + tableCore.pageOptions.limit <=
      tableCore.pageOptions.limit
        ? tableCore.pageOptions.count != -1
          ? tableCore.pageOptions.offset * tableCore.pageOptions.limit + tableCore.pageOptions.limit >=
            tableCore.pageOptions.count
            ? tableCore.pageOptions.count
            : tableCore.pageOptions.offset * tableCore.pageOptions.limit + tableCore.pageOptions.limit
          : columnsI.length
        : tableCore.pageOptions.count != -1
        ? tableCore.pageOptions.count
        : columnsI.length
    }}
    {{ 'common.of' | translate }}
    {{ tableCore.pageOptions.count != -1 ? tableCore.pageOptions.count : columnsI.length }}
    {{ 'common.total' | translate }}
  </div>
</div> -->
